import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { CSSProperties, FC } from "react";

import { CourseStationContext, useCourseStation } from "@ryde/redux";
import {
  DragTypeStationEnum,
  isCourseStationDragOrderable,
  IStationCourseProps,
  TDragDropCourseSortable,
} from "@ryde/shared";

import { StationRowCourse } from "./station.row.course";
import { CourseStationStyled } from "./stations.course.styled";

export const StationCourse: FC<IStationCourseProps> = props => {
  const { station, courseDto, isDragClone, isFirstStation, isLastStation } =
    props;

  const courseStationHookData = useCourseStation(props);

  const isStationDraggable = isCourseStationDragOrderable({
    station,
    isFirstStation,
    isLastStation,
    isSingleStation: isFirstStation && isLastStation,
    stations: courseDto?.metadata?.stationsInfo,
  });

  const dragData: Omit<TDragDropCourseSortable, "sortable"> = {
    type: DragTypeStationEnum.STATION,
    payload: props,
  };

  const {
    attributes,
    listeners,
    setNodeRef,
    isDragging,
    transform,
    transition,
  } = useSortable({
    id: station.id,
    data: dragData,
    disabled: !isStationDraggable,
  });

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition: transition || undefined,
  };

  return (
    <CourseStationContext.Provider
      value={{
        ...props,
        ...courseStationHookData,
        courseDto,
        isDragging,
        listeners,
        attributes,
      }}
    >
      <CourseStationStyled
        $isDragging={isDragging}
        $isDragClone={isDragClone}
        style={style}
        data-e2e-id={station.id}
        ref={isStationDraggable ? setNodeRef : null}
      >
        <StationRowCourse />
      </CourseStationStyled>
    </CourseStationContext.Provider>
  );
};
